const ALL_HTML_TAGS = /(<([^>]+)>)/gi;
export const cleanHtmlTags = (str: string): string =>
  str.replace(ALL_HTML_TAGS, '');

const EMPTY_HTML_TAGS = /<([A-z]+)([^/>^]*)>\s*<\/\1>/gim;
export const cleanEmptyHtmlTags = (str: string): string =>
  str.replace(EMPTY_HTML_TAGS, '');
